import { render } from "./Statistic.vue?vue&type=template&id=732f6fd9"
import script from "./Statistic.vue?vue&type=script&lang=js"
export * from "./Statistic.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/farmfeed-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__